import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf3084cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "arcode-main-toolbar" }
const _hoisted_2 = { class: "menu-container" }
const _hoisted_3 = { class: "toolbar-menu top-menu" }
const _hoisted_4 = ["data-tippy-content", "onClick", "onKeyup"]
const _hoisted_5 = { class: "toolbar-menu bottom-menu" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["data-tippy-content", "onClick", "onKeyup"]

import { ref, reactive, onMounted, computed } from 'vue';
import { ToolbarOption } from '@/core/interfaces/ToolbarOption';
import FileExplorer from '@/components/panel/FileExplorer.vue';
import RunAndDebug from '@/components/panel/RunAndDebug.vue';
import UserSettings from '@/components/panel/UserSettings.vue';
import AccountsManager from '@/components/panel/AccountsManager.vue';
import DeployContract from '@/components/panel/DeployContract.vue';
import HelpInfo from '@/components/panel/HelpInfo.vue';
import SearchArweave from '@/components/panel/SearchArweave.vue';
import DefaultIcon from '@/components/atomic/DefaultIcon';
import tippy from 'tippy.js';
// import ArCodeGallery from '@/components/panel/ArCodeGallery.vue';
import ArCodeLab from '@/components/panel/ArCodeLab.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainToolbar',
  props: {
	workspace: Object,
	tokenState: Object,
	iframe: Boolean,
	tx: String,
	hideToolbar: Boolean,
	login: Object,
	networkParam: String
},
  setup(__props) {

const props = __props;


const showPanel = ref(false);
const selectedOption = ref('');
const options = reactive<Record<string, Record<string, ToolbarOption>>>({
	'primary': {
		'file-explorer': {
			id: 'file-explorer',
			icon: 'codicon-files',
			label: 'File Explorer',
			active: false
		},
		'explore': {
			id: 'explore',
			icon: 'codicon-search',
			label: 'Arweave Explorer',
			active: false
		},
		'deploy': {
			id: 'deploy',
			icon: 'codicon-rocket',
			label: 'Deploy',
			active: false
		},
		'compile': {
			id: 'compile',
			icon: 'codicon-debug-alt',
			label: 'Run and Debug',
			active: false
		},
		/*
		// Remove Gallery temporarily
		'gallery': {
			id: 'gallery',
			icon: 'codicon-circuit-board',
			label: 'ArCode Gallery',
			active: false
		},
		*/
		'lab': {
			id: 'lab',
			icon: 'codicon-beaker',
			label: 'Lab',
			active: false
		},
	},
	'secondary': {
		'accounts': {
			id: 'accounts',
			icon: 'codicon-account',
			label: 'Accounts',
			active: false
		},
		'settings': {
			id: 'settings',
			icon: 'codicon-gear',
			label: 'Settings',
			active: false
		},
		'help': {
			id: 'help',
			icon: 'codicon-question',
			label: 'Help',
			active: false
		}
	}
	
});

const initialContainerWidth = 220;
const sideContainerWidth = ref(initialContainerWidth);
const arcodeExternalTab = computed(() => {
	return `#/${props.tx}`;
});

const select = (optionId: string, optionType: string, event: Event) => {
	const target: HTMLAnchorElement = event.currentTarget as HTMLAnchorElement;

	// Clear previous selected option
	if (selectedOption.value && 
			options['primary'][selectedOption.value] && 
			options['primary'][selectedOption.value].active) {
		options['primary'][selectedOption.value].active = false;
	}
	else if (selectedOption.value && 
					options['secondary'][selectedOption.value] &&
					options['secondary'][selectedOption.value].active) {
		options['secondary'][selectedOption.value].active = false;
	}

	// Show/hide panel
	if (showPanel.value && 
			(target.className === 'active' || target.className === 'active focus-visible')) {
		showPanel.value = false;
		target.className = '';
	} else {
		showPanel.value = true;
		target.className = 'active';
		sideContainerWidth.value = initialContainerWidth;
	}
	options[optionType][optionId].active = true;

	// Save selected option
	selectedOption.value = optionId;
};

const resize = () => {
	const doResize = (event: MouseEvent) => {
			sideContainerWidth.value = event.clientX - 48;
	};

	const stopResize = () => {
		document.documentElement.removeEventListener('mousemove', doResize, false);
		document.documentElement.removeEventListener('mouseup', stopResize, false);
	};
	document.documentElement.addEventListener('mouseup', stopResize, false);
	document.documentElement.addEventListener('mousemove', doResize, false);
};

onMounted(() => {
	tippy('[data-tippy-content]', {
		arrow: true,
		placement: 'right',
		delay: [1000, 100]
	});

	function responsiveToolbar(x) {
		if (x.matches) { 
			showPanel.value = true;
			selectedOption.value = 'file-explorer';
			options['primary']['file-explorer'].active = true;
		} else {
			showPanel.value = false;
			selectedOption.value = '';
			options['primary']['file-explorer'].active = false;
		}
	}

	// Collapse/show toolbar 
	if (!props.hideToolbar) {
		const x = window.matchMedia("(min-width: 700px)")
		responsiveToolbar(x);
	}

});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options['primary'], (option) => {
          return (_openBlock(), _createElementBlock("li", {
            key: option.id
          }, [
            _createElementVNode("a", {
              tabindex: "0",
              "data-tippy-content": option.label,
              class: _normalizeClass({ active: option.active }),
              onClick: ($event: any) => (select(option.id, 'primary', $event)),
              onKeyup: _withKeys(($event: any) => (select(option.id, 'primary', $event)), ["enter"])
            }, [
              _createVNode(_unref(DefaultIcon), {
                class: "icon-toolbar",
                icon: option.icon
              }, null, 8, ["icon"])
            ], 42, _hoisted_4)
          ]))
        }), 128))
      ]),
      _createElementVNode("ul", _hoisted_5, [
        (__props.iframe)
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _createElementVNode("a", {
                tabindex: "0",
                class: "icon-toolbar-link",
                "data-tippy-content": "Open in a New tab",
                href: _unref(arcodeExternalTab),
                target: "_blank"
              }, [
                _createVNode(_unref(DefaultIcon), {
                  class: "icon-toolbar",
                  icon: "codicon-link-external"
                })
              ], 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options['secondary'], (optionSec) => {
          return (_openBlock(), _createElementBlock("li", {
            key: optionSec.id
          }, [
            _createElementVNode("a", {
              tabindex: "0",
              "data-tippy-content": optionSec.label,
              class: _normalizeClass({ active: optionSec.active }),
              onClick: ($event: any) => (select(optionSec.id, 'secondary', $event)),
              onKeyup: _withKeys(($event: any) => (select(optionSec.id, 'secondary', $event)), ["enter"])
            }, [
              _createVNode(_unref(DefaultIcon), {
                class: "icon-toolbar",
                icon: optionSec.icon
              }, null, 8, ["icon"])
            ], 42, _hoisted_8)
          ]))
        }), 128))
      ])
    ]),
    (showPanel.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "side-container",
          style: _normalizeStyle({ width: `${sideContainerWidth.value}px` })
        }, [
          (options['primary']['file-explorer'].active)
            ? (_openBlock(), _createBlock(FileExplorer, {
                key: 0,
                tx: __props.tx,
                login: __props.login,
                networkParam: __props.networkParam,
                workspace: __props.workspace
              }, null, 8, ["tx", "login", "networkParam", "workspace"]))
            : _createCommentVNode("", true),
          (options['primary']['compile'].active)
            ? (_openBlock(), _createBlock(RunAndDebug, {
                key: 1,
                tx: __props.tx,
                login: __props.login,
                iframe: __props.iframe,
                networkParam: __props.networkParam,
                workspace: __props.workspace,
                tokenState: __props.tokenState
              }, null, 8, ["tx", "login", "iframe", "networkParam", "workspace", "tokenState"]))
            : _createCommentVNode("", true),
          (options['primary']['explore'].active)
            ? (_openBlock(), _createBlock(SearchArweave, {
                key: 2,
                tx: __props.tx,
                login: __props.login,
                networkParam: __props.networkParam
              }, null, 8, ["tx", "login", "networkParam"]))
            : _createCommentVNode("", true),
          (options['primary']['deploy'].active)
            ? (_openBlock(), _createBlock(DeployContract, {
                key: 3,
                login: __props.login,
                iframe: __props.iframe,
                networkParam: __props.networkParam,
                workspace: __props.workspace,
                tokenState: __props.tokenState
              }, null, 8, ["login", "iframe", "networkParam", "workspace", "tokenState"]))
            : _createCommentVNode("", true),
          (options['primary']['lab'].active)
            ? (_openBlock(), _createBlock(ArCodeLab, {
                key: 4,
                tx: __props.tx,
                login: __props.login,
                workspace: __props.workspace,
                tokenState: __props.tokenState
              }, null, 8, ["tx", "login", "workspace", "tokenState"]))
            : _createCommentVNode("", true),
          (options['secondary']['settings'].active)
            ? (_openBlock(), _createBlock(UserSettings, {
                key: 5,
                workspace: __props.workspace
              }, null, 8, ["workspace"]))
            : _createCommentVNode("", true),
          (options['secondary']['accounts'].active)
            ? (_openBlock(), _createBlock(AccountsManager, {
                key: 6,
                login: __props.login,
                iframe: __props.iframe,
                tokenState: __props.tokenState,
                networkParam: __props.networkParam
              }, null, 8, ["login", "iframe", "tokenState", "networkParam"]))
            : _createCommentVNode("", true),
          (options['secondary']['help'].active)
            ? (_openBlock(), _createBlock(HelpInfo, {
                key: 7,
                tokenState: __props.tokenState
              }, null, 8, ["tokenState"]))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    (showPanel.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "side-resize",
          onMousedown: _cache[0] || (_cache[0] = ($event: any) => (resize($event)))
        }, null, 32))
      : _createCommentVNode("", true)
  ]))
}
}

})